import { PayloadFilterExternalValidations } from "../../../../../../hooks/filter/typing"
import { DepartmentWithoutConfig } from "../../../../../../service/department/responses";
import { removeAllReference } from "../../../../../../utils/methods/removedReference"
import { Format, Item } from "../../../../../../utils/types/generals";

export const formatInputs = async ({ body, name, value, setFilterData, getDepartmentsWithoutConfig }: PayloadFilterExternalValidations & {
    getDepartmentsWithoutConfig: ({ areasIds }: { areasIds: string[]; }) => Format<DepartmentWithoutConfig>
}) => {
    let localeBody: Record<string, any> = removeAllReference(body)
    if (name === 'areas') {
        if(!(value instanceof Array)) {
            const areasIds = value?.value ? [value?.value] : []
            getDepartmentsWithoutConfig({ areasIds })
            
            setFilterData((prev) => ({
                ...prev,
                departments: [],
            }))
            return { localeBody }
        }
        const areasIds = (value as Item[]).map(item => item.value)
        getDepartmentsWithoutConfig({ areasIds })
        
        const newDepartments = (localeBody.departments as Item[])?.filter((department) => value.find((area: any) => area.value == department.areaId))
        setFilterData((prev) => ({
            ...prev,
            departments: newDepartments,
        }))
        return { localeBody }
    }
    return { localeBody }
}